export class ApiClientConfig {
  apiEndpoint!: string;
}
